/**
 * Recursively remove undefined values for Firestore writes (undefined is not allowed).
 * Preserve Firestore sentinels (serverTimestamp, deleteField, etc.) — they are plain objects whose
 * enumerable props may be empty; recursing would turn them into `{}` and break writes.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function isFirestoreFieldValueSentinel(obj: any): boolean {
  const name = obj?.constructor?.name;
  // Modular SDK names these DeleteFieldValueImpl, ServerTimestampFieldValueImpl, and so on.
  return typeof name === 'string' && name.includes('FieldValue');
}

/**
 * Recursively remove undefined values for Firestore writes (undefined is not allowed).
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function removeUndefinedDeep(obj: any): any {
  if (obj === null || obj === undefined) return obj;
  if (isFirestoreFieldValueSentinel(obj)) return obj;
  if (Array.isArray(obj)) {
    return obj.map(item => removeUndefinedDeep(item));
  }
  if (typeof obj === 'object' && !(obj instanceof Date)) {
    // Preserve Firestore Timestamp-like values
    if (obj && typeof (obj as { toDate?: () => Date }).toDate === 'function') {
      return obj;
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const cleaned: Record<string, any> = {};
    for (const [key, value] of Object.entries(obj)) {
      if (value !== undefined) {
        cleaned[key] = removeUndefinedDeep(value);
      }
    }
    return cleaned;
  }
  return obj;
}
